import useProtoMethod from "./useProtoMethod";
import {
  CreateFamilyRequest,
  CreateFamilyResponse,
  FetchAdvisorNotificationStatusesRequest,
  FetchAdvisorNotificationStatusesResponse,
  FetchAdvisorProfileRequest,
  FetchAdvisorProfileResponse,
  GetFamilyDetailsRequest,
  GetFamilyDetailsResponse,
  ListActivitySubscriptionsRequest,
  ListActivitySubscriptionsResponse,
  ListAdvisorFamiliesRequest,
  ListAdvisorFamiliesResponse,
  ListAllAdvisorsRequest,
  ListAllAdvisorsResponse,
  UpdateAdvisorRequest,
  UpdateAdvisorResponse,
  UpdateActivitySubscriptionRequest,
  UpdateActivitySubscriptionResponse,
  UpdateFamilyRequest,
  UpdateFamilyResponse,
  GetConversationFeedResponse,
  GetConversationFeedRequest,
  FetchPhoneInboxResponse,
  FetchPhoneInboxRequest,
  StartExternalConversationResponse,
  StartExternalConversationRequest,
  GetTextMessageEntryRequest,
  GetTextMessageEntryResponse,
  UpdateExternalContactResponse,
  UpdateExternalContactRequest,
  GetExternalContactPhoneRequest,
  GetExternalContactPhoneResponse,
  FetchInvoiceHistoryRequest,
  FetchInvoiceHistoryResponse,
  ActivateFamilyResponse,
  ActivateFamilyRequest,
  DeactivateFamilyRequest,
  DeactivateFamilyResponse,
  ChangeFamilyPlanResponse,
  ChangeFamilyPlanRequest,
  AddHoursRequest,
  AddHoursResponse,
  RematchAdvisorRequest,
  RematchAdvisorResponse,
  ReactivateFamilyRequest,
  ReactivateFamilyResponse,
  UpdateFeatureFlagRequest,
  UpdateFeatureFlagResponse,
  UpdateAdvisorServiceRequest,
  UpdateAdvisorServiceResponse,
  CreateRematchSessionRequest,
  CreateRematchSessionResponse,
} from "protogen/advisors_service_pb";

const useListAdvisorFamilies = (
  callback?: (r: ListAdvisorFamiliesResponse) => void,
) => {
  return useProtoMethod<
    ListAdvisorFamiliesRequest,
    ListAdvisorFamiliesResponse
  >("ListAdvisorFamilies", ListAdvisorFamiliesResponse, { callback });
};

const useFetchAdvisorNotificationStatuses = (
  callback?: (r: FetchAdvisorNotificationStatusesResponse) => void,
) => {
  return useProtoMethod<
    FetchAdvisorNotificationStatusesRequest,
    FetchAdvisorNotificationStatusesResponse
  >(
    "FetchAdvisorNotificationStatuses",
    FetchAdvisorNotificationStatusesResponse,
    {
      callback,
    },
  );
};

const useListAllAdvisors = (
  callback?: (r: ListAllAdvisorsResponse) => void,
) => {
  return useProtoMethod<ListAllAdvisorsRequest, ListAllAdvisorsResponse>(
    "ListAllAdvisors",
    ListAllAdvisorsResponse,
    { callback },
  );
};

const useCreateFamily = (callback?: (r: CreateFamilyResponse) => void) => {
  return useProtoMethod<CreateFamilyRequest, CreateFamilyResponse>(
    "CreateFamily",
    CreateFamilyResponse,
    { callback },
  );
};

const useUpdateFamily = (callback?: (r: UpdateFamilyResponse) => void) => {
  return useProtoMethod<UpdateFamilyRequest, UpdateFamilyResponse>(
    "UpdateFamily",
    UpdateFamilyResponse,
    { callback },
  );
};

const useGetFamilyDetails = (
  callback?: (r: GetFamilyDetailsResponse) => void,
) => {
  return useProtoMethod<GetFamilyDetailsRequest, GetFamilyDetailsResponse>(
    "GetFamilyDetails",
    GetFamilyDetailsResponse,
    { callback },
  );
};

const useGetTextMessageEntry = (
  callback?: (r: GetTextMessageEntryResponse) => void,
) => {
  return useProtoMethod<
    GetTextMessageEntryRequest,
    GetTextMessageEntryResponse
  >("GetTextMessageEntry", GetTextMessageEntryResponse, {
    callback,
  });
};

const useListActivitySubscriptions = () => {
  return useProtoMethod<
    ListActivitySubscriptionsRequest,
    ListActivitySubscriptionsResponse
  >("ListActivitySubscriptions", ListActivitySubscriptionsResponse);
};

const useUpdateAdvisor = (callback?: (r: UpdateAdvisorResponse) => void) => {
  return useProtoMethod<UpdateAdvisorRequest, UpdateAdvisorResponse>(
    "UpdateAdvisor",
    UpdateAdvisorResponse,
    { callback },
  );
};

const useUpdateActivitySubscription = (
  callback?: (r: UpdateActivitySubscriptionResponse) => void,
) => {
  return useProtoMethod<
    UpdateActivitySubscriptionRequest,
    UpdateActivitySubscriptionResponse
  >("UpdateActivitySubscription", UpdateActivitySubscriptionResponse, {
    callback,
  });
};

const useFetchAdvisorProfile = (
  callback?: (r: FetchAdvisorProfileResponse) => void,
) => {
  return useProtoMethod<
    FetchAdvisorProfileRequest,
    FetchAdvisorProfileResponse
  >("FetchAdvisorProfile", FetchAdvisorProfileResponse, { callback });
};

const useGetConversationFeed = (
  callback?: (r: GetConversationFeedResponse) => void,
) => {
  return useProtoMethod<
    GetConversationFeedRequest,
    GetConversationFeedResponse
  >("GetConversationFeed", GetConversationFeedResponse, { callback });
};

const useFetchPhoneInbox = (
  callback?: (r: FetchPhoneInboxResponse) => void,
) => {
  return useProtoMethod<FetchPhoneInboxRequest, FetchPhoneInboxResponse>(
    "FetchPhoneInbox",
    FetchPhoneInboxResponse,
    { callback },
  );
};

const useStartExternalConversation = (
  callback?: (r: StartExternalConversationResponse) => void,
) => {
  return useProtoMethod<
    StartExternalConversationRequest,
    StartExternalConversationResponse
  >("StartExternalConversation", StartExternalConversationResponse, {
    callback,
  });
};

const useUpdateExternalContact = (
  callback?: (r: UpdateExternalContactResponse) => void,
) => {
  return useProtoMethod<
    UpdateExternalContactRequest,
    UpdateExternalContactResponse
  >("UpdateExternalContact", UpdateExternalContactResponse, {
    callback,
  });
};

const useGetExternalContactPhone = (
  callback?: (r: GetExternalContactPhoneResponse) => void,
) => {
  return useProtoMethod<
    GetExternalContactPhoneRequest,
    GetExternalContactPhoneResponse
  >("GetExternalContactPhone", GetExternalContactPhoneResponse, {
    callback,
  });
};

const useFetchInvoiceHistory = (
  callback?: (r: FetchInvoiceHistoryResponse) => void,
) => {
  return useProtoMethod<
    FetchInvoiceHistoryRequest,
    FetchInvoiceHistoryResponse
  >("FetchInvoiceHistory", FetchInvoiceHistoryResponse, {
    callback,
  });
};

const useActivateFamily = (callback?: (r: ActivateFamilyResponse) => void) => {
  return useProtoMethod<ActivateFamilyRequest, ActivateFamilyResponse>(
    "ActivateFamily",
    ActivateFamilyResponse,
    {
      callback,
    },
  );
};

const useDeactivateFamily = (
  callback?: (r: DeactivateFamilyResponse) => void,
) => {
  return useProtoMethod<DeactivateFamilyRequest, DeactivateFamilyResponse>(
    "DeactivateFamily",
    DeactivateFamilyResponse,
    {
      callback,
    },
  );
};

const useChangeFamilyPlan = (
  callback?: (r: ChangeFamilyPlanResponse) => void,
) => {
  return useProtoMethod<ChangeFamilyPlanRequest, ChangeFamilyPlanResponse>(
    "ChangeFamilyPlan",
    ChangeFamilyPlanResponse,
    { callback },
  );
};

const useAddHours = (callback?: (r: AddHoursResponse) => void) => {
  return useProtoMethod<AddHoursRequest, AddHoursResponse>(
    "AddHours",
    AddHoursResponse,
    { callback },
  );
};

const useRematchAdvisor = (callback?: (r: RematchAdvisorResponse) => void) => {
  return useProtoMethod<RematchAdvisorRequest, RematchAdvisorResponse>(
    "RematchAdvisor",
    RematchAdvisorResponse,
    { callback },
  );
};

const useReactivateFamily = (
  callback?: (r: ReactivateFamilyResponse) => void,
) => {
  return useProtoMethod<ReactivateFamilyRequest, ReactivateFamilyResponse>(
    "ReactivateFamily",
    ReactivateFamilyResponse,
    { callback },
  );
};

const useUpdateFeatureFlag = (
  callback?: (r: UpdateFeatureFlagResponse) => void,
) => {
  return useProtoMethod<UpdateFeatureFlagRequest, UpdateFeatureFlagResponse>(
    "UpdateFeatureFlag",
    UpdateFeatureFlagResponse,
    { callback },
  );
};

const useUpdateAdvisorService = (
  callback?: (r: UpdateAdvisorServiceResponse) => void,
) => {
  return useProtoMethod<
    UpdateAdvisorServiceRequest,
    UpdateAdvisorServiceResponse
  >("UpdateAdvisorService", UpdateAdvisorServiceResponse, { callback });
};

const useCreateRematchSession = (
  callback?: (r: CreateRematchSessionResponse) => void,
) => {
  return useProtoMethod<
    CreateRematchSessionRequest,
    CreateRematchSessionResponse
  >("CreateRematchSession", CreateRematchSessionResponse, { callback });
};

export {
  useListAdvisorFamilies,
  useFetchAdvisorNotificationStatuses,
  useListAllAdvisors,
  useCreateFamily,
  useUpdateFamily,
  useGetFamilyDetails,
  useGetTextMessageEntry,
  useListActivitySubscriptions,
  useUpdateActivitySubscription,
  useFetchAdvisorProfile,
  useUpdateAdvisor,
  useGetConversationFeed,
  useFetchPhoneInbox,
  useStartExternalConversation,
  useUpdateExternalContact,
  useFetchInvoiceHistory,
  useActivateFamily,
  useGetExternalContactPhone,
  useDeactivateFamily,
  useChangeFamilyPlan,
  useAddHours,
  useRematchAdvisor,
  useReactivateFamily,
  useUpdateFeatureFlag,
  useUpdateAdvisorService,
  useCreateRematchSession,
};
